import { useContext, useEffect, useState } from 'react';
import { Button, Card, Col, Row, Table } from 'reactstrap';
import { FichaTecnicaBombeamento } from 'models/FichaTecnicaBombeamento';
import {
  ColQuestaoTitulo,
  LabelQuestaoTitulo,
} from 'views/pages/OrcamentoResultado/styles';
import FichaTecnica from 'models/FichaTecnica';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import api from 'services/api';
import ValidarAcessoPrograma from 'models/ValidarAcessoPrograma';
import { FaCheckCircle } from 'react-icons/fa';
import Swal from 'sweetalert2';
import toast from 'react-hot-toast';
import { Td } from './styles';
import { AdutoraBombeamentoNewContext } from '../..';

interface iListas {
  atts: number[];
  attsPotencia: number[];
  caboEletrico: number[];
}
function Eletrica({ isBM }: { isBM: boolean }): JSX.Element {
  const {
    fichaTecnicaBombeamento,
    acessoProgramas,
    atualizarFuncoes,
    fichaTecnica,
    necessidadeReprocessamento,
    isParteAlternado,
  } = useContext(AdutoraBombeamentoNewContext);

  const [mostrarConteudo, setMostrarConteudo] = useState(false);
  const [fichaBombeamento, setFichaBombeamento] =
    useState<FichaTecnicaBombeamento>();
  const [ficha, setFicha] = useState<FichaTecnica>();
  const [listas, setListas] = useState<iListas>();
  const [acessoPrograma, setAcessoPrograma] = useState(
    {} as ValidarAcessoPrograma,
  );

  const [novoAtts, setNovoAtts] = useState<number>();
  const [novoAttsPotencia, setNovoAttsPotencia] = useState<number>();
  const [novoCaboEletrico, setNovoCaboEletrico] = useState<number>();
  const [isSaving, setIsSaving] = useState(false);
  const [ignorarMaterial, setIgnorarMaterial] = useState(false);
  const [fichaId, setFichaId] = useState(0);

  useEffect(() => {
    if (fichaTecnicaBombeamento && fichaTecnica) {
      const fichaBombeamentoFiltro = fichaTecnicaBombeamento?.filter(
        item => item.isBalsa === false,
      );

      setIgnorarMaterial(
        fichaBombeamentoFiltro?.[0]?.ignorarGeracaoMateriaisEletrica ?? false,
      );

      setNovoAtts(Number(fichaBombeamentoFiltro?.[0]?.tensaoNominal ?? 0));
      setFichaId(Number(fichaBombeamentoFiltro?.[0]?.id ?? 0));
      setNovoAttsPotencia(Number(fichaTecnica?.potenciaATTSElevador ?? 0));
      setNovoCaboEletrico(Number(fichaBombeamentoFiltro?.[0]?.bitolaCabo ?? 0));
      setFichaBombeamento(fichaBombeamentoFiltro?.[0]);
      setFicha(fichaTecnica);
    }
  }, [fichaTecnicaBombeamento, fichaTecnica]);

  async function carregarCamposEletrica() {
    const response = await api.get('/integracao/eletrica/todas-listas');
    setListas(response.data as iListas);
  }

  useEffect(() => {
    if (acessoProgramas && acessoProgramas.length) {
      setAcessoPrograma(
        acessoProgramas?.find(item => item.programa === 67) ?? {
          acessoLimitado: false,
          temAcesso: false,
        },
      );
    }
  }, [acessoProgramas]);

  useEffect(() => {
    carregarCamposEletrica();
  }, []);

  useEffect(() => {
    if (fichaBombeamento && necessidadeReprocessamento) {
      let mostrar = false;

      const reprocessar =
        necessidadeReprocessamento?.reprocessarBombeamento ?? false;

      if (!reprocessar) {
        if (
          fichaBombeamento.bitolaCabo ||
          fichaBombeamento.tensaoNominal ||
          isBM
        ) {
          mostrar = true;
        }
      }

      setMostrarConteudo(mostrar);
    }
  }, [fichaBombeamento, necessidadeReprocessamento]);

  async function salvar() {
    let vaiSalvar = false;
    try {
      setIsSaving(true);

      const valor = await Swal.fire({
        title: `Atenção`,
        html: `<div style='text-align: justify!important; text-justify: inter-word;'>
          Ao salvar alterações dos campos <i>Diâmetro do Cabo</i>, <i>Potência</i> ou <i>Trafo</i>, o novo valor não vai refletir em cálculos já realizados. Para voltar aos valores originais, será necessário o reprocessamento dos lances e o cálculo de adutora/bombeamento. Deseja prosseguir?</div>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `Sim, prosseguir`,
        confirmButtonColor: '#d33',
        cancelButtonText: `Não`,
      });

      vaiSalvar = valor.isConfirmed;
      if (valor.isConfirmed) {
        toast.loading('Salvando...');
        await api.put(`/ficha-tecnica/${ficha?.id}/dados-eletrica`, {
          potencia: String(novoAttsPotencia),
          diametro: Number(novoCaboEletrico),
          trafo: Number(novoAtts),
        });

        atualizarFuncoes(['ELETRICA'], false);
      }
    } finally {
      toast.dismiss();
      if (vaiSalvar) toast.success('Alterações salvas');
      setIsSaving(false);
    }
  }

  async function handleCheckbox({
    id,
    checked,
  }: {
    id: number;
    checked: boolean;
  }) {
    if (!ficha?.orcamentoVersaoId) return;

    const toastId = toast.loading(
      `${checked ? 'Marcando' : 'Desmarcando'} elétrica. Aguarde`,
    );

    await api.put(`/orcamento/${ficha.orcamentoVersaoId}/alternado-materiais`, {
      id,
      checked,
      tipo: 'E',
    });

    setIgnorarMaterial(checked);

    toast.dismiss(toastId);

    toast.success(
      `Elétrica terá seus materiais ${
        checked ? 'desconsiderados' : 'considerados'
      }`,
    );
  }

  return (
    <>
      <Card className="shadow">
        <Row className="mt--3">
          <ColQuestaoTitulo>
            <LabelQuestaoTitulo>Elétrica</LabelQuestaoTitulo>
          </ColQuestaoTitulo>
        </Row>
        <Row hidden={!isParteAlternado}>
          <Col sm="12">
            <FormControlLabel
              className="ml-1 mt-1 float-right "
              control={
                <Checkbox
                  checked={ignorarMaterial}
                  color="primary"
                  onChange={event =>
                    handleCheckbox({
                      id: fichaId,
                      checked: event.target.checked,
                    })
                  }
                  className="mr-1 float-right"
                  title="Ao marcar, todos os materiais relacionados não serão gerados ao concluir etapa"
                />
              }
              label="Ignorar na geração de materiais"
            />
          </Col>
        </Row>

        <Row hidden={mostrarConteudo}>
          <Col className="mt-2 pb-4">
            As informações serão mostradas após a execução do cálculo do
            bombeamento.
          </Col>
        </Row>

        <Row hidden={!mostrarConteudo}>
          <Col sm="2" className="mt-2 mb-2" hidden={isBM}>
            <FormControl fullWidth>
              <InputLabel>Diâmetro do cabo alim. Pivô</InputLabel>
              <Select
                disabled={!acessoPrograma.temAcesso}
                value={novoCaboEletrico ?? ''}
                label="Diâmetro do cabo alim. Pivô"
                autoWidth
                onChange={event =>
                  setNovoCaboEletrico(event.target.value as number)
                }
              >
                {listas?.caboEletrico
                  ?.filter(
                    item => item >= Number(fichaBombeamento?.bitolaCabo ?? 0),
                  )
                  .map(item => (
                    <MenuItem key={`caboEletrico_${item}`} value={item}>
                      {`${item} mm²`}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Col>
          <Col sm="2" className="mt-2 mb-2 ml-1" hidden={isBM}>
            <TextField
              disabled
              size="small"
              label="Queda Tensão"
              value={`${fichaBombeamento?.quedaTensao} %`}
            />
          </Col>
          <Col sm="2" className="mt-2 mb-2">
            <TextField
              disabled
              size="small"
              label="Potência nominal trafo"
              value={`${fichaBombeamento?.potenciaCaboTrafoTransformador} kVA`}
            />
          </Col>
          <Col sm="2" className="mt-2 mb-2" hidden={isBM}>
            <FormControl fullWidth>
              <InputLabel>Potência</InputLabel>
              <Select
                disabled={!acessoPrograma.temAcesso}
                value={novoAttsPotencia ?? ''}
                label="Potência"
                autoWidth
                onChange={event =>
                  setNovoAttsPotencia(event.target.value as number)
                }
              >
                {listas?.attsPotencia
                  ?.filter(
                    item => item >= Number(ficha?.potenciaATTSElevador ?? 0),
                  )
                  .map(item => (
                    <MenuItem key={`attsPotencia_${item}`} value={item}>
                      {`${item} kVA`}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Col>
          <Col sm="2" className="mt-2 mb-2" hidden={isBM}>
            <FormControl fullWidth>
              <InputLabel>Trafo</InputLabel>
              <Select
                disabled={!acessoPrograma.temAcesso}
                value={novoAtts ?? ''}
                label="Trafo"
                autoWidth
                onChange={event => setNovoAtts(event.target.value as number)}
              >
                {listas?.atts
                  ?.filter(
                    item =>
                      item >= Number(fichaBombeamento?.tensaoNominal ?? 0),
                  )
                  .map(item => (
                    <MenuItem key={`atts_${item}`} value={item}>
                      {`${item} V`}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Col>

          <Col sm="1" className="mt-2 mb-2" hidden={!acessoPrograma.temAcesso}>
            <div className="pull-right float-right mr-4 mt-4">
              <Button
                disabled={isSaving}
                hidden={isBM}
                className="btn-iconmr-0 btn-4"
                color="primary"
                type="button"
                size="sm"
                onClick={() => salvar()}
              >
                <FaCheckCircle />
              </Button>
            </div>
          </Col>

          <Col sm="12">
            <Table responsive bordered>
              <thead>
                <tr>
                  <th>Tipo</th>
                  <th>Fases</th>
                  <th>Nrº Pernas</th>
                  <th>Neutro</th>
                  <th>Nrº Pernas</th>
                  <th>Terra</th>
                  <th>Nrº Pernas</th>
                  <th>Distância</th>
                </tr>
              </thead>
              <tbody>
                <tr key={1}>
                  <Td>Disjuntor_QC</Td>
                  <Td>{fichaBombeamento?.disjuntorQCFases || ''}</Td>
                  <Td>{fichaBombeamento?.disjuntorQCPernasFases || ''}</Td>
                  <Td>{fichaBombeamento?.disjuntorQCNeutro || ''}</Td>
                  <Td>{fichaBombeamento?.disjuntorQCPernasNeutro || ''}</Td>
                  <Td>{fichaBombeamento?.disjuntorQCTerra || ''}</Td>
                  <Td>{fichaBombeamento?.disjuntorQCPernasTerra || ''}</Td>
                  <Td>{fichaBombeamento?.disjuntorQCDistancia || ''}</Td>
                </tr>
                <tr key={2}>
                  <Td>QC_Motor</Td>

                  <Td>{fichaBombeamento?.qcMotorFases || ''}</Td>
                  <Td>{fichaBombeamento?.qcMotorPernasFases || ''}</Td>
                  <Td>{fichaBombeamento?.qcMotorNeutro || ''}</Td>
                  <Td>{fichaBombeamento?.qcMotorPernasNeutro || ''}</Td>
                  <Td />
                  <Td />
                  <Td>{fichaBombeamento?.qcMotorDistancia || ''}</Td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
      </Card>
    </>
  );
}

export default Eletrica;
